import * as React from "react";

import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { FormState, UseFormRegister } from "react-hook-form/dist/types";

const Row = styled("div")(() => ({
  marginBottom: "30px",
  display: "flex",
  justifyContent: "space-between",
}));

interface TemplateNameInputProps {
  register: UseFormRegister<any>;
  formState: FormState<any>;
}

export const TemplateNameInput: React.FC<TemplateNameInputProps> = ({ register, formState }) => {
  return (
    <>
      <Row>
        <TextField
          fullWidth
          variant="outlined"
          id="template-name"
          inputProps={{
            "data-testid": "template-name",
          }}
          label="Template Name *"
          helperText={formState.errors?.templateName?.message || "Please specify a Template Name"}
          {...register("templateName")}
          error={!!formState?.errors?.templateName}
        />
      </Row>
    </>
  );
};
